export default "__VITE_ASSET__741f39a8__"